import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import {useAuth} from "../providers/AuthProvider";
import {useToast} from "use-toast-mui";
import {AuthState} from "../enums";

export const AdminLoginScreen = () => {
    const {authState, logIn} = useAuth();
    const toast = useToast();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            mx: 'auto'
        }}>
            <Typography variant="h4">Admin Portal</Typography>
            <Button variant="contained" startIcon={<GoogleIcon/>} sx={{mt: 2, textDecoration: 'none'}}
                    onClick={async () => {
                        try {
                            await logIn()
                        } catch (error) {
                            toast.error(`Error signing in with Google: ${error}`);
                        }
                    }}>
                Sign In with Google
            </Button>
            {
                (authState !== AuthState.ADMIN && authState !== AuthState.NONE) &&
                <Typography variant="body2" sx={{mt: 2, color: 'red'}}>You do not have access to this
                    portal.</Typography>
            }
        </Box>
    );
}
